import {
  TradingOffer,
  TradingOfferStatus,
} from 'types/TradingOffer';

import { getOfferStatus } from './getOfferStatus';

export type TradingOfferManageVisibilityParams = {
  offer: TradingOffer;
  isAdmin: boolean;
  userPartnerIds: string[];
};

export const getTradingOfferManageActionsVisibility = ({
  offer,
  isAdmin,
  userPartnerIds,
}: TradingOfferManageVisibilityParams): {
  canModify: boolean;
  canCancel: boolean;
} => {
  if (offer.canceledAt) {
    return { canModify: false, canCancel: false };
  }

  if ((offer.sharesCount?.agreed ?? 0) > 0) {
    return { canModify: false, canCancel: false };
  }

  const publisherId =
    typeof offer.partner === 'string'
      ? offer.partner
      : offer.partner?._id || '';
  const publisherIdStr = publisherId ? String(publisherId) : '';
  const isPublisher =
    Boolean(publisherIdStr) && userPartnerIds.includes(publisherIdStr);

  if (!isAdmin && !isPublisher) {
    return { canModify: false, canCancel: false };
  }

  const status = getOfferStatus(offer);

  if (status === TradingOfferStatus.ACCEPTED) {
    return { canModify: false, canCancel: false };
  }

  const canCancel =
    status === TradingOfferStatus.ACTIVE ||
    status === TradingOfferStatus.EXPIRED;

  const canModify = status === TradingOfferStatus.ACTIVE;

  return { canModify, canCancel };
};
